import { useState, useEffect, useCallback } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Cookie } from 'lucide-react';
import { updateConsent } from '../utils/analytics';

export const CookieConsent = () => {
  const [visible, setVisible] = useState(() => {
    return !localStorage.getItem('cookieConsent');
  });

  // Allow reopening the banner from anywhere via custom event
  const handleReopen = useCallback(() => {
    setVisible(true);
  }, []);

  useEffect(() => {
    window.addEventListener('reopen-cookie-consent', handleReopen);
    return () => window.removeEventListener('reopen-cookie-consent', handleReopen);
  }, [handleReopen]);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    updateConsent(true);
    setVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem('cookieConsent', 'declined');
    updateConsent(false);
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
          className="fixed bottom-0 left-0 right-0 z-50"
        >
          <div className="bg-[#07516B]/95 backdrop-blur-xl border-t border-white/10">
            <div className="container-custom py-4 md:py-5">
              <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
                <Cookie size={24} className="text-[#FBAF3F] flex-shrink-0 hidden sm:block" />
                <p className="text-white/80 text-sm leading-relaxed flex-grow">
                  Ez a weboldal cookie-kat (sütiket) használ a megfelelő működés érdekében.
                  További információért olvassa el{' '}
                  <Link
                    to="/cookie-tajekoztato"
                    className="text-[#C4DB72] hover:text-white underline transition-colors"
                  >
                    Cookie tájékoztatónkat
                  </Link>.
                </p>
                <div className="flex gap-3 flex-shrink-0 w-full sm:w-auto">
                  <button
                    onClick={handleDecline}
                    className="flex-1 sm:flex-initial px-6 py-2.5 border border-white/20 text-white/80 hover:bg-white/10 text-sm font-medium transition-all duration-300"
                  >
                    Elutasítom
                  </button>
                  <button
                    onClick={handleAccept}
                    className="flex-1 sm:flex-initial px-6 py-2.5 bg-[#FBAF3F] text-black hover:bg-[#C4DB72] text-sm font-semibold transition-all duration-300"
                  >
                    Elfogadom
                  </button>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
